import {
  CalendarClock,
  Megaphone,
  MessageSquare,
  ShieldCheck,
  TrendingDown,
  TriangleAlert,
  UserPlus,
  Clock,
  type LucideIcon,
} from 'lucide-react';
import type { NotificationKind } from '@/graphql/generated';

/**
 * Icono y tono de cada tipo de notificación. Los tonos son semánticos: un aviso
 * de SLA incumplido es «peligro» y una asignación es sólo información.
 */
const META: Record<NotificationKind, { Icon: LucideIcon; tone: string }> = {
  TICKET_ASIGNADO: { Icon: UserPlus, tone: 'bg-info-subtle text-info-subtle-fg' },
  TICKET_ESCALADO: { Icon: TriangleAlert, tone: 'bg-danger-subtle text-danger-subtle-fg' },
  SLA_POR_VENCER: { Icon: Clock, tone: 'bg-warning-subtle text-warning-subtle-fg' },
  SLA_INCUMPLIDO: { Icon: TriangleAlert, tone: 'bg-danger-subtle text-danger-subtle-fg' },
  MENSAJE_NUEVO: { Icon: MessageSquare, tone: 'bg-primary-subtle text-primary-subtle-fg' },
  SEGUIMIENTO_HOY: { Icon: CalendarClock, tone: 'bg-info-subtle text-info-subtle-fg' },
  GARANTIA_POR_VENCER: { Icon: ShieldCheck, tone: 'bg-warning-subtle text-warning-subtle-fg' },
  CLIENTE_EN_RIESGO: { Icon: TrendingDown, tone: 'bg-danger-subtle text-danger-subtle-fg' },
  CAMPANIA_FINALIZADA: { Icon: Megaphone, tone: 'bg-accent-subtle text-accent-subtle-fg' },
};

export function notificationIcon(kind: NotificationKind) {
  return META[kind] ?? { Icon: MessageSquare, tone: 'bg-surface-sunken text-fg-muted' };
}
